var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: _vm.id } }, [
    _c(
      "span",
      {
        staticClass: "rating-stars",
        attrs: {
          title:
            _vm.__("Rating") + ": " + _vm.internal_value + "/" + _vm.max_rating,
        },
      },
      [
        _c("span", {
          staticClass: "rating-value",
          style: "width: " + _vm.percentage + "%",
        }),
      ]
    ),
    _vm._v(" "),
    _vm.showVoterCount
      ? _c("span", { staticClass: "rating-count ml-2" }, [
          _vm._v(
            _vm._s(_vm.voterCount) +
              " " +
              _vm._s(
                _vm.voterCount === 1 ? _vm.__("Rating") : _vm.__("Ratings")
              )
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }